import React from 'react';
import { Button, Modal, Form } from 'antd';
import { useDispatch } from 'react-redux'
import { DataRequestAction } from 'redux/actions/http'
interface Values {
  title: string;
  description: string;
  modifier: string;
}

interface CollectionCreateFormProps {
  visible: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}

const CollectionCreateForm: React.FC<CollectionCreateFormProps> = ({
  visible,
  onCreate,
  onCancel,
  confirmLoading,
  modalTitle,
  submitButtonText,
  cancelButtonText,
  children,
  initialValues,
  initialRecord,
  width,
  shouldClearForm,
  className,
  onlyEdit
}) => {

  const [form] = Form.useForm();
  
  if (shouldClearForm) {
    form.resetFields();
  }


  if (initialValues) {
    if (initialValues !== "adding") {
      
      form.setFieldsValue(initialValues)
    }
  } else {
    
    form.setFieldsValue(initialRecord);
  }

  return (

    <Modal
      visible={visible}
      title={modalTitle}
      width={width}
      form={form}
      bodyStyle={{
        paddingLeft: 0,
        paddingRight: 0
      }}
      okText={submitButtonText}
      cancelText={cancelButtonText}
      className={className}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      confirmLoading={confirmLoading}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onCreate(values);
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
      >
        {children}
      </Form>
    </Modal>
  );
};

const CollectionsPage = ({ children, modalTitle,
  basicButtonTitle,
  submitButtonText,
  cancelButtonText,
  confirmLoading,
  apiMethod,
  apiName,
  visible,
  ModalType,
  editApiMethod,
  editApiName,
  initialRecord,
  width,
  initialValues,
  shouldClearForm,
  className,
  form,
  apiLoaderName,onlyEdit, buttonStyleClass, isShowButton = true, extraFieldName, extraFieldValue }) => {

  const dispatch = useDispatch();
  const onCreate = values => {

    console.log('formData',values)

    if (extraFieldName) {
      values[extraFieldName] = extraFieldValue
    }

    if(onlyEdit){
      dispatch(DataRequestAction(editApiMethod, editApiName, values, '', apiLoaderName, false))
    }
    
    if (initialValues) {
      values._id = initialValues._id;
      if(values.email){
        values.email = values.email.toLowerCase();
      }
      dispatch(DataRequestAction(editApiMethod, editApiName, values, '', apiLoaderName, false))
    }
     else {
      console.log('form submit success', values)
      if(!onlyEdit){

        if(values.email){
          values.email = values.email.toLowerCase();
        }
        dispatch(DataRequestAction(apiMethod, apiName, values, '', apiLoaderName, false))
      }
      
    }
  };

  return (
    <div>
      {isShowButton && <Button
        type="primary"
        className={`gx-pt-0 ${buttonStyleClass}`}
        onClick={() => {
          console.log("========== calling ========");
          dispatch({
            type: ModalType,
            payload: null
          })
        }}
      >
        {basicButtonTitle}
      </Button>}
      <CollectionCreateForm
        modalTitle={modalTitle}
        submitButtonText={submitButtonText}
        cancelButtonText={cancelButtonText}
        apiMethod={apiMethod}
        apiName={apiName}
        ModalType={ModalType}
        initialValues={initialValues}
        initialRecord={initialRecord}
        confirmLoading={confirmLoading}
        apiLoaderName={apiLoaderName}
        shouldClearForm={shouldClearForm}
        visible={visible}
        width={width}
        className={className}
        form={form}
        onlyEdit={onlyEdit}
        onCreate={onCreate}
        onCancel={() => {
          dispatch({

            type: ModalType,
            payload: null,
            clear: true
          })
        }}
      >
        {children}
      </CollectionCreateForm>
    </div>
  );
};

export default CollectionsPage;